<link rel="ractive" href="../components/placeholder-skeleton.html" name="c-placeholder-skeleton">

<div class="c-gp-results-table-output">
	<div class="results-table-wrapper" on-scroll="@this.hideSetLocationButton(@event)">
		<div class="results-table {{#if targetsCnt === 1}}single-target{{/if}}">
			<div class="results-table_header">
				<button class="results-table_header_cell location" on-click="@this.onSortClick('location')">
					Location
					<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('location')}}">
				</button>

				{{#if targetsCnt > 1}}
					<div class="results-table_header_cell targets"></div>
				{{/if}}

				<button class="results-table_header_cell quality" on-click="@this.onSortClick('quality')">
					Quality
					<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('quality')}}">
				</button>

				<div class="results-table_header_cell rtt">
					<button class="rtt_text" on-click="@this.onSortClick('rtt-last')">
						rtt last
						<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('rtt-last')}}">
					</button>
					<span class="rtt_separator">/</span>
					<button class="rtt_text" on-click="@this.onSortClick('min')">
						min
						<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('min')}}">
					</button>
					<span class="rtt_separator">/</span>
					<button class="rtt_text" on-click="@this.onSortClick('avg')">
						avg
						<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('avg')}}">
					</button>
					<span class="rtt_separator">/</span>
					<button class="rtt_text" on-click="@this.onSortClick('max')">
						max
						<img width="8" alt="" src="{{@shared.assetsHost}}/img/{{@this.getSortIcon('max')}}">
					</button>
				</div>
				<div class="results-table_header_cell ip">Resolved IP</div>
				<div class="results-table_header_cell graph">Graph</div>
			</div>

			{{#each preparedTestResults}}
				<div class="results-table_row row-num-{{this.clientSideId}} item-id-{{this.clientSideId}}"
					tabindex="0"
					role="button"
					aria-label="Set as location for the next test"
					on-focus="@this.enableItemFocused(@event, this.clientSideId)"
					on-blur="@this.hideSetLocationButton(@event)"
					on-keydown="@this.headerKeydownHandler(@event, this.clientSideId)"
					on-mouseenter="@this.showSetLocationButton(this.clientSideId)"
					on-mouseleave="@this.hideSetLocationButton(@event)"
				>
					<div class="results-table_row_location">
						<span class="results-table_row_location_status-line">
							<span
								class="results-table_row_location_status-line_top"
								style="background-color: {{_.getGpProbeStatusColor(this.statsPerTarget[0].avgTiming)}}">
							</span>
							<span
								class="results-table_row_location_status-line_bottom"
								style="background-color: {{_.getGpProbeStatusColor(this.statsPerTarget[1] ? this.statsPerTarget[1].avgTiming : this.statsPerTarget[0].avgTiming)}}">
							</span>
						</span>

						<img width="28" height="20" alt="" src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{this.country}}.svg">

						<div class="results-table_row_location_data">
							<span>{{this.city}}, {{this.country}}, {{this.continent}}</span>
							<span>{{this.network}}</span>
						</div>
					</div>

					<div class="results-table_row_stats">
						{{#each this.statsPerTarget}}
							<div class="results-table_row_stats_subrow">
								{{#if targetsCnt > 1}}
									<div class="results-table_row_stats_subrow_cell targets">
										<div class="results-table_row_stats_subrow_cell_value">
											{{#if this.target}}
												<span>{{this.target}}</span>
											{{elseif testInProgress}}
												<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
											{{else}}
												<span>—</span>
											{{/if}}
										</div>
									</div>
								{{/if}}

								{{#if this.isFailed}}
									<div class="results-table_row_stats_subrow_cell probe-failed">
										<span>{{PROBE_FAILED_TEXT}}</span>
										<div as-tooltip="`${this.failureRawOutput}`, 'top', true">
											<img width="20" height="20" alt="" src="{{@shared.assetsHost}}/img/target-icon.svg">
										</div>
									</div>
								{{elseif this.isOffline && !isInfiniteModeRes}}
									<div class="results-table_row_stats_subrow_cell probe-offline">
										<span>{{PROBE_OFFLINE_TEXT}}</span>
									</div>
								{{else}}
									<div class="results-table_row_stats_subrow_cell quality">
										<div class="results-table_row_stats_subrow_cell_value">
											<span class="results-table_row_stats_subrow_cell_value_header">Quality</span>
											{{#if this.qualityStr}}
												<span>{{this.qualityStr}}</span>
											{{elseif testInProgress}}
												<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
											{{else}}
												<span>—</span>
											{{/if}}
										</div>
									</div>

									<div class="results-table_row_stats_subrow_cell rtt">
										<div class="results-table_row_stats_subrow_cell_value">
											<span class="timings {{#unless areTimingsReady}}no-value{{/unless}}">
												<span class="timings_header">
													<span>rtt&nbsp;</span>
													<span>last</span>
												</span>

												{{#if this.areTimingsReady}}
													<span class="timings_value">
														{{@this.formatTimingValue(this.lastTiming)}}
														{{#if this.lastTiming !== PROBE_NO_TIMING_VALUE}}
															<span class="timings_units">ms</span>
														{{/if}}
													</span>
												{{elseif !this.areTimingsReady && testInProgress}}
													<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
												{{else}}
													<span>—</span>
												{{/if}}
											</span>

											<span class="timings_separator">/</span>

											<span class="timings {{#unless areTimingsReady}}no-value{{/unless}}">
												<span class="timings_header">
													<span>rtt&nbsp;</span>
													<span>min</span>
												</span>

												{{#if this.areTimingsReady}}
													<span class="timings_value">
														{{@this.formatTimingValue(this.minTiming)}}
														{{#if this.minTiming !== PROBE_NO_TIMING_VALUE}}
															<span class="timings_units">ms</span>
														{{/if}}
													</span>
												{{elseif !this.areTimingsReady && testInProgress}}
													<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
												{{else}}
													<span>—</span>
												{{/if}}
											</span>

											<span class="timings_separator">/</span>

											<span class="timings {{#unless areTimingsReady}}no-value{{/unless}}">
												<span class="timings_header">
													<span>rtt&nbsp;</span>
													<span>avg</span>
												</span>

												{{#if this.areTimingsReady}}
													<span class="timings_value">
														{{@this.formatTimingValue(this.avgTiming)}}
														{{#if this.avgTiming !== PROBE_NO_TIMING_VALUE}}
															<span class="timings_units">ms</span>
														{{/if}}
													</span>
												{{elseif !this.areTimingsReady && testInProgress}}
													<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
												{{else}}
													<span>—</span>
												{{/if}}
											</span>

											<span class="timings_separator">/</span>

											<span class="timings {{#unless areTimingsReady}}no-value{{/unless}}">
												<span class="timings_header">
													<span>rtt&nbsp;</span>
													<span>max</span>
												</span>

												{{#if this.areTimingsReady}}
													<span class="timings_value">
														{{@this.formatTimingValue(this.maxTiming)}}
														{{#if this.maxTiming !== PROBE_NO_TIMING_VALUE}}
															<span class="timings_units">ms</span>
														{{/if}}
													</span>
												{{elseif !this.areTimingsReady && testInProgress}}
													<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
												{{else}}
													<span>—</span>
												{{/if}}
											</span>

											{{#if this.areTimingsReady
												&& this.minTiming !== PROBE_NO_TIMING_VALUE
												&& this.avgTiming !== PROBE_NO_TIMING_VALUE
												&& this.maxTiming !== PROBE_NO_TIMING_VALUE
											}}
												<span class="lg-screen-units">ms</span>
											{{/if}}
										</div>
									</div>

									<div class="results-table_row_stats_subrow_cell ip">
										<div class="results-table_row_stats_subrow_cell_value">
											<span class="results-table_row_stats_subrow_cell_value_header"><span class="hidden-xs">Resolved </span>IP</span>
											{{#if this.ipAddr}}
												<span class="visible-lg"> <!-- We break in two lines if the value has more than 4 non-empty groups. -->
													{{#each splitIPv6(ipAddr)}}
														{{this}}<br>
													{{/each}}
												</span>
												<span class="hidden-lg text-ellipsis">{{this.ipAddr}}</span>
											{{elseif !this.ipAddr && testInProgress}}
												<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
											{{else}}
												<span>—</span>
											{{/if}}
										</div>
									</div>

									<div class="results-table_row_stats_subrow_cell graph">
										<div class="results-table_row_stats_subrow_cell_value">
											<span class="results-table_row_stats_subrow_cell_value_header">Graph</span>
											{{#if typeof this.packetsRtt !== 'undefined' && this.packetsRtt.length}}
												<div>{{{ @this.createGraph(this.packetsRtt) }}}</div>
											{{elseif testInProgress && testInProgress}}
												<c-placeholder-skeleton type="subheader"></c-placeholder-skeleton>
											{{else}}
												<span>—</span>
											{{/if}}
										</div>
									</div>
								{{/if}}
							</div>
						{{/each}}
					</div>
				</div>
			{{/each}}
		</div>
	</div>

	{{#if floatingSetLocationButton.visible}}
		<div class="c-gp-results-table-output_set-location-hitarea"
			style="top: {{floatingSetLocationButton.top}}px; left: {{floatingSetLocationButton.left-4}}px; height: {{floatingSetLocationButton.height}}px;"
			on-mouseleave="@this.hideSetLocationButton(@event)">
			<button class="c-gp-results-table-output_set-location {{#if itemFocused}}focus-outline{{/if}}"
				type="button"
				tabindex="-1"
				style="top: {{floatingSetLocationButton.buttonTop}}px;"
				as-tooltip="'Set as location for the next test', 'right'"
				on-focus="@this.set('itemFocused', true)"
				on-blur="@this.hideSetLocationButton(@event)"
				on-click="@this.setProbeAsLocation()"
				aria-label="Set as location for the next test">
				<i class="fa fa-map-marker" aria-hidden="true"></i>
			</button>
		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const listeners = require('../../assets/js/utils/listeners');
	const PROBE_MAX_TIMING = 200;
	const PROBE_MIN_TIMING = 5;
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_OFFLINE_TEXT = 'Probe offline';
	const PROBE_FAILED_TEXT = 'Probe failed';

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				_,
				PROBE_NO_TIMING_VALUE,
				PROBE_OFFLINE_TEXT,
				PROBE_FAILED_TEXT,
				splitIPv6 (address) {
					let segments = address.split(':');

					if (segments.filter(Boolean).length <= 4) {
						return [ address ];
					}

					let splitAt = segments[3] ? 4 : 3;

					return [ segments.slice(0, splitAt).join(':'), ':' + segments.slice(splitAt).join(':') ];
				},
				chartMaxHeight: 0,
				sortBy: 'location',
				sortOrder: 'asc',
				floatingSetLocationButton: {
					visible: false,
					top: 0,
					left: 0,
					height: 0,
					buttonTop: 0,
					probeData: null,
				},
				itemFocused: false,
				justFocusedItem: false,
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				this.observe('preparedTestResults', () => {
					let preparedTestResults = this.get('preparedTestResults') || [];

					if (!preparedTestResults.length) { return; }

					this.setChartMaxHeight(preparedTestResults);
				});

				this.observe('sortOrder sortBy', () => {
					let listWrapperEl = this.find('.results-table-wrapper');

					if (listWrapperEl) {
						listWrapperEl.scrollTop = 0;
					}
				}, { init: false });

				this._onSetLocationViewportChange = (event) => {
					this.hideSetLocationButton(event);
				};

				listeners.addManagedListener(this, window, 'resize', this._onSetLocationViewportChange);
				listeners.addManagedListener(this, window, 'scroll', this._onSetLocationViewportChange);
			}
		},
		// --- set location button logic ---
		isSetLocationFocusActive (setLocationButton) {
			let activeElement = document.activeElement;

			return (setLocationButton && setLocationButton.contains(activeElement))
				|| activeElement?.classList.contains('results-table_row');
		},
		showSetLocationButton (clientSideId) {
			let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
			let rowNode = document.querySelector(`.item-id-${clientSideId}`);
			let rowLocation = rowNode?.querySelector('.results-table_row_location');
			let container = this.find('.c-gp-results-table-output');
			let listContainer = this.find('.results-table-wrapper');

			this.set('itemFocused', false);

			if (!rowNode || !rowLocation || !container || !listContainer) { return; }

			let listRect = listContainer.getBoundingClientRect();
			let rowLocationRect = rowLocation.getBoundingClientRect();
			let visibilityOverflowTolerancePx = 15;
			let isRowLocationVisible = rowLocationRect.top >= (listRect.top - visibilityOverflowTolerancePx)
				&& rowLocationRect.bottom <= (listRect.bottom + visibilityOverflowTolerancePx);

			if (!isRowLocationVisible) {
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let rowRect = rowNode.getBoundingClientRect();
			let containerRect = container.getBoundingClientRect();
			let relativeTop = rowRect.top - containerRect.top;
			let relativeLeft = rowLocationRect.left - containerRect.left;

			this.set('floatingSetLocationButton', {
				visible: true,
				probeData,
				top: relativeTop,
				left: relativeLeft - 26,
				height: rowRect.height,
				buttonTop: rowLocationRect.top - rowRect.top + rowLocationRect.height / 2 - 13,
			});
		},
		hideSetLocationButton (event) {
			if (this.get('justFocusedItem')) {
				if (event?.type !== 'scroll') {
					this.set('justFocusedItem', false);
				}

				return;
			}

			if (event?.type === 'scroll') {
				this.set('floatingSetLocationButton.visible', false);
				this.set('itemFocused', false);
				return;
			}

			if (!this.get('floatingSetLocationButton.visible') && !this.get('itemFocused')) {
				return;
			}

			let setLocationButton = this.find('.c-gp-results-table-output_set-location');
			let setLocationHitarea = this.find('.c-gp-results-table-output_set-location-hitarea');

			if (event?.type === 'blur' && !event.relatedTarget) {
				requestAnimationFrame(() => {
					this.hideSetLocationButton();
				});

				return;
			}

			if (this.isSetLocationFocusActive(setLocationButton)) {
				return;
			}

			if (event?.type === 'blur' && setLocationButton?.contains(event.relatedTarget)) {
				return;
			}

			if (event && event.relatedTarget && event.type !== 'blur') {
				let container = event.target.closest('.results-table_row');
				let relatedContainer = event.relatedTarget.closest?.('.results-table_row');

				if ((container && container.contains(event.relatedTarget))
					|| relatedContainer
					|| (setLocationHitarea && setLocationHitarea.contains(event.relatedTarget))) {
					return;
				}
			}

			this.set('floatingSetLocationButton.visible', false);
			this.set('itemFocused', false);
		},
		setProbeAsLocation (probeData = this.get('floatingSetLocationButton.probeData')) {
			if (!probeData) { return; }

			this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
			this.set('floatingSetLocationButton.visible', false);
		},
		enableItemFocused (event, clientSideId) {
			if (!event.target?.classList.contains('results-table_row')) {
				return;
			}

			this.showSetLocationButton(clientSideId);
			this.set('itemFocused', true);
			this.set('justFocusedItem', true);

			requestAnimationFrame(() => {
				this.set('justFocusedItem', false);
			});
		},
		headerKeydownHandler (event, clientSideId) {
			if (!event.target?.classList.contains('results-table_row')) {
				return;
			}

			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
				this.setProbeAsLocation(probeData);
			}
		},
		setChartMaxHeight (results) {
			let allPacketRtt = results
				.map(test => Array.isArray(test.statsPerTarget)
					? test.statsPerTarget.map(target => target.packetsRtt).flat()
					: []).flat();

			this.set(
				'chartMaxHeight',
				Math.max(...allPacketRtt.filter(v => typeof v === 'number')),
			);
		},
		createRealTimeGraph (
			data,
			svgWidth = 48,
			svgHeight = 24,
			svgBgColor = '#F4F4F4',
			barWidth = 2,
			gap = 1,
		) {
			let maxValue = this.get('chartMaxHeight');

			if (!data || maxValue === 0) { return; }

			let maxBars = Math.floor(svgWidth / (barWidth + gap));
			let startIndex = Math.max(data.length - maxBars, 0);
			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

			svg.setAttribute('width', svgWidth);
			svg.setAttribute('height', svgHeight);
			svg.style.backgroundColor = svgBgColor;

			for (let i = startIndex; i < data.length; i++) {
				let percentage = data[i] === maxValue || data[i] === PROBE_NO_TIMING_VALUE ? 1 : data[i] / maxValue;
				let barHeight = percentage * svgHeight;
				let x = svgWidth - ((data.length - 1 - i) * (barWidth + gap)) - barWidth;
				let y = svgHeight - barHeight;

				if (x >= 0) {
					let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

					rect.setAttribute('x', x);
					rect.setAttribute('y', y);
					rect.setAttribute('width', barWidth);
					rect.setAttribute('height', barHeight);
					rect.setAttribute('fill', this.pickBarColor(data[i]));
					svg.appendChild(rect);
				}
			}

			return svg.outerHTML;
		},
		createRegularGraph (
			data,
			svgWidth = 48,
			svgHeight = 24,
			svgBgColor = '#F4F4F4',
		) {
			let maxValue = this.get('chartMaxHeight');

			if (!data || data.length === 0 || maxValue === 0) { return; }

			data = data.slice(-20);

			let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			let numBars = data.length;
			let spaceWidth = 1;
			let barWidth = Math.round(svgWidth / numBars - spaceWidth);
			let actualWidth = barWidth * numBars + (numBars - 1) * spaceWidth;

			svg.setAttribute('width', actualWidth > svgWidth ? actualWidth : svgWidth);
			svg.setAttribute('height', svgHeight);
			svg.style.backgroundColor = svgBgColor;

			data.forEach((value, index) => {
				let barHeight = value === PROBE_NO_TIMING_VALUE ? svgHeight : (value / maxValue) * svgHeight;
				let xPosition = index * spaceWidth + index * barWidth;
				let rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

				rect.setAttribute('x', xPosition);
				rect.setAttribute('y', svgHeight - barHeight);
				rect.setAttribute('width', barWidth);
				rect.setAttribute('height', barHeight);
				rect.setAttribute('fill', this.pickBarColor(value));
				svg.appendChild(rect);
			});

			return svg.outerHTML;
		},
		pickBarColor (timing) {
			// return default color for timed out probe
			if (timing === PROBE_NO_TIMING_VALUE) {
				return '#17233A';
			}

			function getColorFromGradient (quotient, start, middle, end) {
				return quotient >= 0.5 ? linear(middle, end, (quotient - 0.5) * 2) : linear(start, middle, quotient * 2);
			}

			function linear (startColor, endColor, quotient) {
				let redColor = byteLinear(startColor[1] + startColor[2], endColor[1] + endColor[2], quotient);
				let greenColor = byteLinear(startColor[3] + startColor[4], endColor[3] + endColor[4], quotient);
				let blueColor = byteLinear(startColor[5] + startColor[6], endColor[5] + endColor[6], quotient);

				return `#${redColor}${greenColor}${blueColor}`;
			}

			function byteLinear (partOne, partTwo, quotient) {
				let color = Math.floor(('0x' + partOne) * (1 - quotient) + ('0x' + partTwo) * quotient);

				return color.toString(16).padStart(2, '0');
			}

			let pureTimingValue = parseInt(timing);

			// '#17d4a7', '#ffb800', '#e64e3d' - colors are used for timings scale on the map
			if (pureTimingValue <= PROBE_MIN_TIMING) {
				return '#17d4a7';
			}

			if (pureTimingValue >= PROBE_MAX_TIMING) {
				return '#e64e3d';
			}

			return getColorFromGradient(pureTimingValue / PROBE_MAX_TIMING, '#17d4a7', '#ffb800', '#e64e3d');
		},
		calcQuality (statsTotal, statsDrop) {
			if (
				typeof statsTotal === 'undefined'
				|| typeof statsDrop === 'undefined'
				|| statsTotal === 0
			) {
				return {
					qualityPercentage: null,
					actualAmount: null,
				};
			}

			let actualAmount = Math.max(statsTotal - statsDrop, 0);
			let qualityPercentage = Math.round(actualAmount / statsTotal * 100);

			return {
				qualityPercentage,
				actualAmount,
			};
		},
		createGraph (packetsRtt) {
			let isInfiniteModeRes = this.get('isInfiniteModeRes');
			let memoizedCreateGraph;

			if (isInfiniteModeRes) {
				memoizedCreateGraph = _.memoize(this.createRealTimeGraph.bind(this));
			} else {
				memoizedCreateGraph = _.memoize(this.createRegularGraph.bind(this));
			}


			return memoizedCreateGraph(packetsRtt);
		},
		formatTimingValue (value) {
			if (typeof value !== 'number' || isNaN(value)) {
				return value;
			}

			if (value < 10) {
				return value.toFixed(2);
			} else if (value < 100) {
				return value.toFixed(1);
			}

			return Math.round(value);
		},
		onSortClick (field) {
			if (field === this.get('sortBy')) {
				this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
			} else {
				this.set('sortBy', field);
				this.set('sortOrder', 'asc');
			}
		},
		toggleSortOrder () {
			this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
		},
		getSortIcon (field) {
			if (field === this.get('sortBy')) {
				return `sort-${this.get('sortOrder')}-sm.svg`;
			}

			return 'sort-none.svg';
		},
	};
</script>
